import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/** 用户筛选条件模版（与 auth UserFilterScheme 对齐） */
export class HdFilterScheme {
  uuid?: string;
  userCode?: string;
  filterKey: string;
  templateName: string;
  filterValue: string;
}

/** 内置默认模版名 */
export const HD_FILTER_DEFAULT_SCHEME_NAME = '默认条件';

/**
 * 业务仓实现并 provide，hd-filter 在 enableFilterScheme 时注入使用。
 * 不提供则开启开关也不会调接口。
 */
export abstract class HdFilterSchemeStore {
  abstract queryByFilterKey(filterKey: string): Observable<Array<HdFilterScheme>>;
  abstract save(scheme: HdFilterScheme): Observable<HdFilterScheme>;
  abstract delete(uuid: string): Observable<void>;
}

export const HD_FILTER_SCHEME_STORE = new InjectionToken<HdFilterSchemeStore>('HD_FILTER_SCHEME_STORE');
